import React from "react";
const AboutUs = () => {
  return (
    <section id="about" className="section">
      <div className="container">
        {/* Heading */}
      
    
        {/* Heading end*/}
        <div className="row">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-4">
              Kommunikation auf den {" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                Punkt 
              </span>
                {" "}gebracht.
            </h2>
            <p className="text-5">
              •	Konzepte und Texte<br></br>
•	Präsentationen und Berichte<br></br>
•	Ghostwriting und Leserbriefe<br></br>
•	Reportagen und Skripts<br></br>
•	Beratung und Coaching

            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
           
          </div>
        </div>
        <div className="row gy-3 mt-4">
        
          <div className="col-12 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0">Kontakt:</p>
            <p className="text-4 fw-600 mb-0">
                denis (at) bernhardt.ch
            </p>
          </div>
         
        
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
